export function deleteCookie(name) {
  const d = new Date(0);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=;${expires};domain=.palettehq.com`;
}
